import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  Input,
} from '@angular/core';
import { SummaryListItem } from '@app/shared/types';

@Component({
  selector: 'inventory-summary',
  templateUrl: 'inventory-summary.component.html',
  styleUrls: ['./inventory-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InventorySummaryComponent {
  @Input() public summaryList: SummaryListItem[] = [];

  public constructor(public injector: Injector) {}

  public fallback() {}
}
